import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    items: [],
    pagination: {
      sortDesc: [true],
      page: 1,
      sortBy: ['flagCreated'],
      itemsPerPage: 25,
      totalItems: 0,
    },
    totalItems: 0,
    filters: {
      clientId: null,
      flagCreatedAt: null,
      sequenceNumber: null,
      status: 0,
    },
    activeTab: 0,
  },
  actions,
  mutations,
  getters: {},
};
